/**
 * useSidebarSkin — skórka wyglądu aplikacji (redesign UI/UX 2026-09).
 *
 * Po zakończeniu etapu porównawczego skórka „antd" (Workflow365 redesign) jest STAŁYM,
 * domyślnym wyglądem — przełącznik (Nasz/Ant/21st) został usunięty. Atrybuty `data-skin`
 * na `<aside>`/pasku kart/tabeli oraz `data-app-skin="antd"` na `<html>` (index.html)
 * aktywują style z `index.css`. Hook zostawiony jako jedno źródło wartości skórki dla
 * komponentów, które stemplują `data-skin`.
 */
export type SidebarSkin = 'current' | 'antd' | 'shadcn';

/** Aktualna (stała) skórka aplikacji. */
export function useSidebarSkin(): SidebarSkin {
  return 'antd';
}
